<table>
	<tr>
		<th>{{ 'assignment.links.details_text' | transloco }}</th>
		<th>
			@if (reportId()) {
				{{ 'assignment.links.report_text' | transloco }}
			}
		</th>
	</tr>
	<tr>
		<td>
			@if (showAdditionalAssignmentLink()) {
				<a
					class="btn-link"
					[routerLink]="[
						'/desk',
						'client',
						clientId(),
						'assignments',
						assignmentId(),
						isServiceOfficeStatementSubmitView()
							? 'edit-fds'
							: isAdditionalAssignmentView()
								? 'edit-additional'
								: 'edit',
					]"
					[queryParams]="{ redirectUrl: redirectUrl() }"
					>{{ 'assignment.links.details_change' | transloco }}
					<mat-icon class="material-symbols-outlined" [inline]="true" [aria-hidden]="true">arrow_forward</mat-icon>
				</a>
			}
		</td>
		<td>
			@if (reportId() && !isServiceOfficeStatementSubmitView() && !isPhase4Target()) {
				<a
					class="btn-link"
					[routerLink]="['/desk', 'client', clientId(), 'assignments', assignmentId(), 'report', reportId()]"
					[queryParams]="{ redirectUrl: redirectUrl() }"
				>
					{{ 'assignment.links.to_start_report' | transloco }}
					<mat-icon class="material-symbols-outlined" [inline]="true" [aria-hidden]="true">arrow_forward</mat-icon>
				</a>
			} @else if (reportId() && !isServiceOfficeStatementSubmitView() && isPhase4Target()) {
				<a
					class="btn-link"
					[routerLink]="['/desk', 'client', clientId(), 'assignments', assignmentId(), 'end-report', reportId()]"
					[queryParams]="{ redirectUrl: redirectUrl() }"
				>
					{{ 'assignment.links.to_end_report' | transloco }}
					<mat-icon class="material-symbols-outlined" [inline]="true" [aria-hidden]="true">arrow_forward</mat-icon>
				</a>
			}
		</td>
	</tr>
</table>
